module.exports = __webpack_public_path__ + "assets/img/jd_icon.b2a710c2.png";